<template>
<div >
  <main class="py-4">
  <v-app>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" >
          <v-col cols="12" sm="8" md="4" >
            <v-card class="elevation-12">
              <v-toolbar class="listra" dark flat >              
                <v-toolbar-title>revelaCha</v-toolbar-title>
                <v-spacer></v-spacer>                
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field v-model="login" label="Código de Acesso" name="login" prepend-icon="mdi-account" type="text"></v-text-field>
                  <v-text-field v-model="password" id="password" label="Chave de Acesso" name="password" prepend-icon="mdi-lock"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <form action="#" @submit.prevent="submit">
                  <v-btn type="submit" outlined tile color="primary" :loading="loading">Login</v-btn>
                </form>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
  </main>
</div>    
</template>
<script>
import { db } from '@/main'

export default {
    data: () => ({
        login: '',
        password: '',
        loading: false
    }),
    methods:{
        async submit() { 
            this.loading = true
            await db.collection('revelacoes').where('URL','==',this.login).get()
            .then((seg) => {    
                this.babyData = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a})[0];
                // console.log(this.babyData, this.chaveDeAcesso)
                if ((typeof this.babyData.chaveDeAcesso != 'undefined') && (this.babyData.chaveDeAcesso == this.password)) {
                    sessionStorage.setItem("loggedIn",true);
                    sessionStorage.setItem("accessCode",this.login);

                    this.$router.replace('/parentsMenu')
                    this.$router.go()
                }
            }).catch(function (error) {
                this.loading = false
                console.error("Error get userss: ", error);
            });              
        } 
    }
}
</script>
<style scoped>
.listra {
    /* background: repeating-linear-gradient(
        #296B74,
        #296B74 20px,
        #1C4C5A 20px,
        #1C4C5A 45px
    ); */
  background: linear-gradient(to right, #51c7fd, #f59cd3);
  background-size: cover;    
}
</style>